import { useAccount } from "@qw/auth";
import {
  type DraftMessageFragment,
  type FindDraftsForEmailInputDto,
  useInboxDraftSentSubscription,
  useInboxDraftsQuery,
} from "@qw/graphql";
import { usePagination } from "@qw/ui";
import { useDraftsFilter } from "./drafts-filter-provider";

type UseDraftsInput = Pick<FindDraftsForEmailInputDto, "insuredId">;

export const useDrafts = (
  input: UseDraftsInput = {}
): Omit<ReturnType<typeof useInboxDraftsQuery>, "data"> & {
  drafts: DraftMessageFragment[];
} => {
  const { filters } = useDraftsFilter();
  const { page, rowsPerPage, setNumRecords } = usePagination();
  const { userInbox } = useAccount();

  const { data, ...restDraftsQuery } = useInboxDraftsQuery({
    variables: {
      input: {
        ...filters,
        ...input,
        page: Number(page) || 1,
        rowsPerPage: Number(rowsPerPage) || 50,
      },
    },
    onCompleted: (data) => setNumRecords(data.inboxDrafts.numRecords),
    fetchPolicy: "cache-and-network",
  });

  useInboxDraftSentSubscription({
    variables: { email: userInbox?.email ?? "" },
    onData: () => restDraftsQuery.refetch(),
    skip: !userInbox?.email,
  });

  return {
    drafts: data?.inboxDrafts.drafts || [],
    ...restDraftsQuery,
  };
};
